// The list in a list response: a paginated `{ result, totalItems }` or a plain array.
// `/profile/time-off/plan` returns either, depending on the usermanager build (TR-522 made it
// return the array `/users/:id/time-off` returns).
export const getResultList = (response) => {
	if (Array.isArray(response)) {
		return response;
	}
	return Array.isArray(response?.result) ? response.result : [];
};
